import {
  FlagUpdatesRuleDetails,
  createFlagUpdatesChangeExtension,
} from '@spotify/plugin-confidence-flags-react';

export const RULE_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'rule-change',
  predicate: ({ change }) =>
    change.fieldType === 'confidence.flags.admin.v1.Flag.Rule',
  render: ({ change }) => (
    <FlagUpdatesRuleDetails
      oldRule={change.oldValue}
      newRule={change.newValue}
    />
  ),
});
